<template>  
  <footer>
    <div class="notice">
    <p>The information provided on this website is general in nature only and does not constitute personal financial advice. Before acting on any information on this website you should consider the appropriateness of the information having regard to your objectives, financial situation and needs. Investing in CFDs and Margin FX Contracts carries significant risks and is not suitable for all investors. You may lose more than your initial deposit. You don’t own, or have, any interest in the underlying assets. We recommend that you seek independent advice and ensure fully understand the risks involved before trading. It is important that you read and consider disclosure documents before you acquire any product listed on the website. The information and advertisements offered on this website are not intended for use by any person in any country or jurisdiction where such use is contrary to the local laws and regulations. Products and Services offered on this website is not intended for residents of the United States.</p>

        <p>F Trade Markets is a company registered in Saint Lucia and registered address Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia, with registration number 2025-00035.</p>

        <p>Email: <a href="mailTo:admin@ftrademarkets.com"> admin@ftrademarkets.com</a></p>
        </div>
			<div class="wrapper">
                <div class="right" >
                    <img src="@/assets/images/logo_bottom.png">
                    <ul class="contact">
                        <li class="til">Contact Us:</li>
                        <li>Telephone: 886-2-27485995</li>
                        <li>Email: admin@ftrademarkets.com</li>
                        <li>{{$t('footer.adr')}}</li>
                    </ul>
                </div>
				<div class="wrap">

					<p class="com-name">{{$t('appName')}}</p>
					<p>Copyright © 2023-2025 F Trade Markets. All rights reserved.</p>
                    
                    <div class="follow">
                        <span>Follow Us On:</span>
                        <ul>
                            <li><img src="@/assets/images/icons/facebook.svg" /></li>                            
                            <li><img src="@/assets/images/icons/x.svg" /></li>
                            <li><img src="@/assets/images/icons/linkedin.svg" /></li>
                            <li><img src="@/assets/images/icons/telegram.svg" /></li>
                        </ul>
                    </div>
					<!-- <ul class="nav" v-if="$i18n.locale=='zh_CN'">
						<li><router-link :to="{name:'privacy_cn'}">{{$t('footer.privacy')}}</router-link></li> | 
						<li><router-link :to="{name:'agreement_cn'}">{{$t('footer.clientAgreement')}}</router-link></li>
					</ul>
					<ul class="nav" v-else>
						<li><router-link :to="{name:'privacy'}">{{$t('footer.privacy')}}</router-link></li> | 
						<li><router-link :to="{name:'agreement'}">{{$t('footer.clientAgreement')}}</router-link></li>
					</ul> -->
				</div>
				
			</div>
            
		</footer>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
footer{			
        padding: 30px 0 100px 0;
        
        .wrapper{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .wrap{				     
                .com-name{
                    font-size: 30px;
                    font-weight: 900;
                }          
                .nav{
                    display: flex;
                    align-items: center;
                    font-size: 15px;
                    margin: .3rem auto;
                    li{
                        margin-right: 30px;
                        a,a:visited{
                            color: white;
                        }
                    }
                }
                .follow{
                    font-size: 15px;
                    margin-top: 10px;
                    line-height: 44px;
                    li{
                        display: inline-block;
                        width: 44px;
                        height: 44px;
                        margin-right:10px;
                        background-color: #fff;
                        border-radius: 50%;
                        line-height: 44px;
                        text-align: center;
                        overflow: hidden;
                        transition: background-color .3s;
                        cursor: pointer;
                        img{
                            width: 24px;
                            margin: 9px auto;
                            display: inline-block;
                        }
                        &:hover{
                            background-color: #43e39a;
                        }
                    }
                }
            }
            .right{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
                line-height: 30px;
                border: 0px solid #43e39a;
                border-radius: 5px;
                padding: 0 10px;
                .contact{
                    margin-left: 30px;
                    max-width: 500px;
                    li{
                        line-height: 1.4em;
                        margin-bottom: 5px;
                        &.til{
                            font-weight: bold;
                            font-size: 18px;
                        }
                    }
                }
                img{
                    width: 100px;
                }
                p{
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 15px;
                }
            }
        }
        .notice{
            width: 95%;
            max-width: 1480px;
            padding: 30px;
            margin: 30px auto;
            border-radius: 15px;
            background-color: rgba($color: #fff, $alpha: .5);
            border: 1px solid #ddd;
            box-sizing: border-box;
            line-height: 1.5em;
            p{
                margin-bottom: 15px;
            }
        }
    }
</style>
